<template>
  <div class="404">
    <div ref="scroll" class="scroll">
      <header class=header>
        <div class="header-container">
          <h1 ref="title">ERROR 404</h1>
          <span ref="subtitle">
            <router-link 
              :to="{ path: '/' }" 
              @mouseenter.native="$emit('mouse', 'hover')" 
              @mouseleave.native="$emit('mouse', 'normal')" >
              Back to home
            </router-link>
          </span>
        </div>
      </header>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notFound',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$anime({
        targets: [vm.$refs.title, vm.$refs.subtitle],
        translateY: [-10, 0],
        opacity: [0, 1],
        duration: 1200,
        delay: vm.$anime.stagger(1000, {start: 2000}),
        easing: 'cubicBezier(0.520, 0.340, 0.005, 0.995)',
      })
    })
  },
  beforeRouteLeave (to, from , next) {
    this.$anime({
      targets: this.$refs.scroll,
      opacity: [1, 0],
      duration: 1200,
      delay: 300,
      easing: 'cubicBezier(0.520, 0.340, 0.005, 0.995)',
      complete: () => {
        this.$emit('scrollTo', { y: 0, now: true })
        this.$emit('load', false)
        next()
      }
    })
  },
}
</script>

<style lang="scss">
.header {
  position: relative;
  z-index: 1;
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  align-items: center;
  justify-content: center;

  &-container {
    @extend %container;
    text-align: center;
  }

  h1 {
    @extend %title;
  }
  
  a{
    @extend %subtitle;
    text-decoration: none;
    color: $darkvanilla;
  }
}
</style>